import { Link } from "react-router-dom";
import { Heart, ArrowLeft } from "lucide-react";

export default function LegalPage({ title, eyebrow, effectiveDate, children }) {
  return (
    <div className="grain-bg min-h-screen relative overflow-hidden">
      <div className="absolute -top-40 -right-24 w-[520px] h-[520px] rounded-full opacity-40 blur-3xl" style={{ background: "radial-gradient(circle, #D4C7E1 0%, transparent 60%)" }} />

      <header className="relative z-10 border-b border-[#EFEBF4]/60">
        <div className="max-w-6xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="h-8 w-8 rounded-full flex items-center justify-center" style={{ background: "#9B8BAF" }}>
              <Heart className="h-3.5 w-3.5 text-white" strokeWidth={2.5} />
            </div>
            <span className="text-base tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              My Daily Prayer
            </span>
          </Link>
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-[#75737A] hover:text-[#2C2A2E] transition-colors">
            <ArrowLeft className="h-3.5 w-3.5" /> Back to home
          </Link>
        </div>
      </header>

      <main className="relative z-10 max-w-3xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="text-[10px] uppercase tracking-[0.22em] text-[#75737A]">{eyebrow}</div>
        <h1 className="mt-3 text-4xl sm:text-5xl leading-tight text-[#2C2A2E]" style={{ fontFamily: "'Playfair Display', serif" }}>
          {title}
        </h1>
        <p className="mt-3 text-xs text-[#75737A]">Effective: {effectiveDate}</p>

        <article className="mt-10 prose-mdp text-[#3F3D42] leading-relaxed text-[15px] space-y-6">
          {children}
        </article>

        <div className="mt-16 pt-8 border-t border-[#EFEBF4] flex items-center justify-between text-xs text-[#75737A]">
          <Link to="/privacy" className="hover:text-[#2C2A2E]">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-[#2C2A2E]">Terms of Service</Link>
          <Link to="/contact" className="hover:text-[#2C2A2E]">Contact</Link>
        </div>
      </main>
    </div>
  );
}
